type TimezoneString = `${string}/${string}`;

/**
 * List of 'canonical' IANA timezones for the continental United States
 *
 * The full list of America/ and US/ options is included here in code for easier
 * future alterations. However, only the most relevant timezones to Caire service are
 * enabled.
 *
 * @see https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
 */
export const timezones: TimezoneString[] = [
  // 'America/Adak',
  // 'America/Anchorage',
  // 'America/Boise',
  // 'America/Chicago',
  // 'America/Denver',
  // 'America/Detroit',
  // 'America/Indiana/Indianapolis',
  // 'America/Indiana/Knox',
  // 'America/Indiana/Marengo',
  // 'America/Indiana/Petersburg',
  // 'America/Indiana/Tell_City',
  // 'America/Indiana/Vevay',
  // 'America/Indiana/Vincennes',
  // 'America/Indiana/Winamac',
  // 'America/Juneau',
  // 'America/Kentucky/Louisville',
  // 'America/Kentucky/Monticello',
  // 'America/Los_Angeles',
  // 'America/Menominee',
  // 'America/Metlakatla',
  // 'America/New_York',
  // 'America/Nome',
  // 'America/North_Dakota/Beulah',
  // 'America/North_Dakota/Center',
  // 'America/North_Dakota/New_Salem',
  // 'America/Phoenix',
  // 'America/Sidka',
  // 'America/Yakutat',
  // 'Pacific/Honolulu',
  // 'US/Alaska',
  'US/Arizona',
  'US/Central',
  'US/Eastern',
  // 'US/Hawaii',
  'US/Mountain',
  'US/Pacific',
  // 'US/Samoa',
];
